import React from 'react';
import { useTranslation } from 'react-i18next';
import { privacyUrl, termsUrl } from '~/config/settings/worktango.settings';
import { mui } from '~/tools/mui';
import { icons } from '~/tools/icons';
import { jss } from '~/tools/jss';
import { ScrollToTop } from '../UI.shared';

const useStyles = jss.makeStyles((theme) => ({
  root: {
    display: 'block',
    backgroundColor: theme.legacyPalette.darkaccent,
    height: '100%',
    width: '100%',
  },
  cardWrapper: {
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    position: 'absolute',
    maxWidth: 600,
    [theme.breakpoints.down('md')]: {
      width: '80%',
    },
  },
  cardFooter: {
    marginTop: 48,
  },
  copyright: {
    color: theme.legacyPalette.darkaccentLight,
    backgroundColor: 'transparent',
    textAlign: 'center',
    marginTop: 16,
    fontSize: '.75rem',
  },
  poweredBy: {
    fontSize: 12,
    margin: 0,
  },
  cardRoot: {
    width: '100%',
    backgroundColor: theme.palette.common.white,
  },
  imgContainer: {
    display: 'flex',
    justifyContent: 'center',
    margin: '24px 24px 0px 24px',
  },
  childContainer: {
    overflow: 'auto',
  },
  link: {
    color: 'white',
  },
  footerText: {
    padding: '0px 8px',
    fontSize: '.75rem',
  },
}));

const AuthLayout = ({ children }) => {
  const styles = useStyles();
  const { t } = useTranslation();

  const currentYear = new Date().getFullYear();

  return (
    <main className={styles.root}>
      <ScrollToTop />
      <section className={styles.cardWrapper}>
        <mui.Card className={styles.cardRoot}>
          <div className={styles.imgContainer}>
            <icons.WorkTangoWordmark alt="WorkTango" />
          </div>
          <div className={styles.childContainer}>{children}</div>
        </mui.Card>

        <mui.Grid container direction="row" justifyContent="center" alignItems="center" className={styles.cardFooter}>
          <mui.Link rel="noreferrer" target="_blank" href={termsUrl} className={styles.link}>
            <mui.Typography className={styles.footerText}>{t('terms.of.use')}</mui.Typography>
          </mui.Link>
          <mui.Link rel="noreferrer" target="_blank" href={privacyUrl} className={styles.link}>
            <mui.Typography className={styles.footerText}>{t('privacy.policy')}</mui.Typography>
          </mui.Link>
        </mui.Grid>

        <mui.Typography className={styles.copyright} component="footer">
          <p className={styles.poweredBy}>{t('copyright', { year: currentYear })}</p>
        </mui.Typography>
      </section>
    </main>
  );
};

export default AuthLayout;
